const clients: any = {
  fr: 'clients',
  en: 'clients',
  es: 'clientes',
  it: 'clienti',
};

const blogArticles: any = {
  fr: 'fiches-pratiques',
  en: 'blog',
  es: 'contenido-practico',
};

export enum Subpath {
  Client,
  BlogArticles,
  Pillar,
}

export const linkResolver = (
  doc: any,
  locale: string,
  params: any = '',
  subpath?: Subpath,
  isAlternate: any = false,
) => {
  if (isAlternate) {
    doc.slug = doc.value;
  }
  if (doc.slug === 'home') {
    if (locale === 'en') {
      return '/';
    }
    return `/${locale}/`;
  }

  if (subpath !== undefined) {
    switch (subpath) {
      case Subpath.Client:
        if (locale === 'en') {
          return `/${clients[locale]}/${doc.slug}/`;
        }
        return `/${locale}/${clients[locale]}/${doc.slug}/`;
      case Subpath.BlogArticles:
        if (locale === 'en') {
          return `/${blogArticles[locale]}/${doc.slug}/`;
        }
        return `/${locale}/${blogArticles[locale]}/${doc.slug}/`;
      case Subpath.Pillar:
        if (doc.treeParent) {
          if (!doc.treeParent.slug) {
            // Return a breaking error if a translated page
            // has no translated parent
            throw new Error(`No parent slug found for ${doc.slug}`);
          }
          if (locale === 'en') {
            return `/${doc.treeParent.slug}/${doc.slug}/`;
          }
          return `/${locale}/${doc.treeParent.slug}/${doc.slug}/`;
        } else {
          if (locale === 'en') {
            return `/${doc.slug}/`;
          }
          return `/${locale}/${doc.slug}/`;
        }
    }
  }

  if (params) {
    if (locale === 'en') {
      return `/${doc.slug}/?${params}`;
    }
    return `/${locale}/${doc.slug}/?${params}`;
  }

  if (locale === 'en') {
    return `/${doc.slug}/`;
  }
  return `/${locale}/${doc.slug}/`;
};
